// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ewA_jNG11CGWNclFhvpb {
    background-color: var(--background);
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0 10px;
    width: var(--width-sidebar);
    flex: 1;
}
.ewA_jNG11CGWNclFhvpb.Qxll2h9I8DW1_srCUBmL.zcag6wXnuZnWuobaWJbg {
    background-color: var(--white);
    left: 0;
    position: absolute;
    top: 0;
    z-index: var(--cross);
    width: var(--width-mobile-sidebar);
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
}

.ewA_jNG11CGWNclFhvpb.Qxll2h9I8DW1_srCUBmL.ZcenhxPK3S4RhL8is4n_ {
    display: none;
}

.rbK62OkqVr1sIYodIN_T {
    height: 60px;
    align-items: center;
    display: flex;
    /* justify-content: space-between; */
    gap: 11px;
}
@media screen and (max-width: 1239px) {
    .rbK62OkqVr1sIYodIN_T {
        height: 60px;
    }
}

@media screen and (max-width: 767px) {
    .rbK62OkqVr1sIYodIN_T {
        height: 50px;
    }
}
.feZ44QDNypZevTYz9gxs {
    position: fixed;
    right: 0;
    top: 0;
    height: 100dvh;
    width: 100vw;
    z-index: var(--over-modal);
    background-color: rgba(126, 150, 191, 0.6);
    border-radius: 0px;
} 
`, "",{"version":3,"sources":["webpack://./src/styles/Sidebar/Sidebar.module.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,2BAA2B;IAC3B,OAAO;AACX;AACA;IACI,8BAA8B;IAC9B,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,qBAAqB;IACrB,kCAAkC;IAClC,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,oCAAoC;IACpC,SAAS;AACb;AACA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI,eAAe;IACf,QAAQ;IACR,MAAM;IACN,cAAc;IACd,YAAY;IACZ,0BAA0B;IAC1B,0CAA0C;IAC1C,kBAAkB;AACtB","sourcesContent":[".sidebar {\n    background-color: var(--background);\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    padding: 0 10px;\n    width: var(--width-sidebar);\n    flex: 1;\n}\n.sidebar.mobile.open {\n    background-color: var(--white);\n    left: 0;\n    position: absolute;\n    top: 0;\n    z-index: var(--cross);\n    width: var(--width-mobile-sidebar);\n    border-top-right-radius: 20px;\n    border-bottom-right-radius: 20px;\n}\n\n.sidebar.mobile.close {\n    display: none;\n}\n\n.top {\n    height: 60px;\n    align-items: center;\n    display: flex;\n    /* justify-content: space-between; */\n    gap: 11px;\n}\n@media screen and (max-width: 1239px) {\n    .top {\n        height: 60px;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .top {\n        height: 50px;\n    }\n}\n.mobiWrapAside {\n    position: fixed;\n    right: 0;\n    top: 0;\n    height: 100dvh;\n    width: 100vw;\n    z-index: var(--over-modal);\n    background-color: rgba(126, 150, 191, 0.6);\n    border-radius: 0px;\n} \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `ewA_jNG11CGWNclFhvpb`,
	"mobile": `Qxll2h9I8DW1_srCUBmL`,
	"open": `zcag6wXnuZnWuobaWJbg`,
	"close": `ZcenhxPK3S4RhL8is4n_`,
	"top": `rbK62OkqVr1sIYodIN_T`,
	"mobiWrapAside": `feZ44QDNypZevTYz9gxs`
};
export default ___CSS_LOADER_EXPORT___;
